import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { useSearchObject } from 'hooks/location';
import userActions from 'actions/user-actions';
import { ROOT_PATH } from 'constants/route-paths';

const ConfirmationSignUp = () => {
  const { siteSlug } = useParams();

  const { token } = useSearchObject();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      dispatch(userActions.confirmUser(token)).finally(() => setLoading(false));
    } else {
      setLoading(false);
      toast.error('Invalid callback url');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <Spinner className='m-auto' animation='border' />
  ) : (
    <Redirect to={siteSlug ? `/${siteSlug}` : ROOT_PATH} />
  );
};

export default ConfirmationSignUp;
